import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva } from "class-variance-authority";
import { cn } from "@tameeni/shared-logic";
import { Icon } from "@tameeni/icons";
const toggleVariants = cva(
  "inline-flex items-center justify-center text-slate-600 min-h-8 px-4 py-1 gap-1 rounded-3xl text-s3 transition-colors border border-slate-300 bg-white hover:bg-slate-50 focus-visible:outline-none focus-visible:bg-slate-100 disabled:pointer-events-none disabled:text-slate-400 data-[state=on]:bg-green-200 data-[state=on]:border-green-200 data-[state=on]:text-slate-900 data-[state=on]:hover:bg-green-300 data-[state=on]:focus-visible:bg-green-400 data-[state=on]:disabled:bg-slate-300 data-[state=on]:disabled:text-slate-400 data-[state=on]:disabled:border-slate-300 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:-ms-2"
);
const Tag = React.forwardRef(({ className, checkIcon, ...props }, ref) => /* @__PURE__ */ jsxs(
  TogglePrimitive.Root,
  {
    ref,
    className: cn(toggleVariants(), className),
    ...props,
    children: [
      checkIcon && /* @__PURE__ */ jsx(Icon, { name: "Checked" }),
      /* @__PURE__ */ jsx("span", { children: props.children })
    ]
  }
));
Tag.displayName = TogglePrimitive.Root.displayName;
export {
  Tag,
  toggleVariants
};
